import { Injectable, isDevMode } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Observable} from "rxjs";
import {Inquiry8080Model} from "./8080Inquiry.model";
import {map} from "rxjs/operators";
import {collection, getCountFromServer, getFirestore, query} from "firebase/firestore";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class Inquiry8080ServiceService {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  collectionName = this.env.inquiry8080;
  constructor(private firestore: AngularFirestore) {}

  getInquiries(): Observable<Inquiry8080Model[]> {
   return  this.firestore.collection<Inquiry8080Model>(this.collectionName).valueChanges({idField: 'id'})
  }
  getInquiryWithId(id: any): Observable<Inquiry8080Model |undefined> {
    return this.firestore.collection(this.collectionName).doc<Inquiry8080Model>(id).valueChanges({ idField: 'id' });
  }



  addInquiry(data: Inquiry8080Model) {
    return this.firestore.collection(this.collectionName).add(data);
  }

  updateInquiry(id: string, data: Inquiry8080Model) {
    return this.firestore.collection(this.collectionName).doc(id).update(data);
  }

  deleteInquiry(id: string) {
   return this.firestore.collection(this.collectionName).doc(id).delete();
  }
  get8080Count(): Observable<number> {
    return this.firestore.collection(this.collectionName).valueChanges().pipe(
      map(docs => docs.length) // just count documents
    );
  }

  //* Count-only variant using Firestore count() aggregation — avoids downloading full documents just to read .length
  get8080CountFromServer(): Promise<number> {
    const q = query(collection(getFirestore(), this.collectionName))
    return getCountFromServer(q).then(snap => snap.data().count)
  }

  migratePurposeToArray() {
    this.firestore.firestore.collection(this.collectionName)
      .get()
      .then(snapshot => {
        const batch = this.firestore.firestore.batch();

        snapshot.docs.forEach(doc => {
          const data: any = doc.data();
          const docRef = doc.ref;

          const purpose = data.purpose;

          // Only migrate if purpose is a non-empty string (old structure)
          if (typeof purpose === 'string' && purpose.trim() !== '') {
            batch.update(docRef, {
              purpose: [purpose]  // wrap string into array
            });
          }

          // If purpose is missing or empty string, set to empty array
          if (purpose === undefined || purpose === null || purpose === '') {
            batch.update(docRef, {
              purpose: []
            });
          }

          // If already an array, skip — no update needed
        });

        return batch.commit();
      })
      .then(() => {
        console.log('Purpose bulk migration to array completed successfully!');
      })
      .catch(error => {
        console.error('Error during purpose migration:', error);
      });
  }
}
